import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IconTypes } from '~/components/Icon/IconTypes';
import { ModalType } from '~/components/Modal/interface';

import { catalogStore, mainStore, userStore } from '~/stores';

import { useModal } from './useModal';

export const useNotifyMe = (
  productId: number,
  sku: string,
  isBundle: boolean,
  disabledModal: boolean = false,
): {
  notifyMeOnClick: () => void;
  notifyMeIcon: IconTypes;
  notifyMeIconV2: IconTypes;
  notifyMeButtonText: string;
  btnClassName: string;
  isLoading: boolean;
  isSubscribed: boolean;
} => {
  const { t } = useTranslation();
  const { openModal } = useModal();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (userStore.isAuthorized && !catalogStore.notifyMeStore.gotSKUS) {
      catalogStore.notifyMeStore.getNotifyMeSKUList();
    }
  }, []);

  const isSubscribed =
    catalogStore.notifyMeStore.notifyMeSKUMap[productId]?.includes(sku) ??
    false;

  let notifyMeOnClick = async () => {
    setIsLoading(true);
    const res = await catalogStore.notifyMeStore.addNotifyMe(productId, sku);
    setIsLoading(false);
    if (!res) {
      mainStore.pushAlert('error', t('errors:oops'));
      return;
    }
    if (!disabledModal) {
      openModal(ModalType.Subscription);
    }
  };
  let notifyMeIcon = 'notification' as IconTypes;
  let notifyMeIconV2 = 'notificationV2' as IconTypes;
  let notifyMeButtonText = t('notifyMe');
  let btnClassName = '';

  if (isSubscribed) {
    notifyMeOnClick = async () => {
      setIsLoading(true);
      const res = await catalogStore.notifyMeStore.deleteNotifyMe(
        productId,
        sku,
      );
      setIsLoading(false);
      if (!res) {
        mainStore.pushAlert('error', t('errors:oops'));
        return;
      }
      if (!disabledModal) {
        openModal(ModalType.SubscriptionOff);
      }
    };
    notifyMeIcon = 'notification-not' as IconTypes;
    notifyMeIconV2 = 'notificationV2-not' as IconTypes;
    notifyMeButtonText = t('unsubscribe');
    btnClassName = 'subscribed';
  }

  if (!userStore.isAuthorized) {
    notifyMeOnClick = async () => {
      await openModal(ModalType.Auth);
    };
  }

  if (isBundle) {
    notifyMeOnClick = async () => void 0;
    notifyMeIcon = 'bag' as IconTypes;
    notifyMeButtonText = t('soldOut');
    btnClassName = '_disabled';
  }

  return {
    notifyMeOnClick,
    notifyMeIcon,
    notifyMeIconV2,
    notifyMeButtonText,
    btnClassName,
    isLoading,
    isSubscribed,
  };
};
